import { connect } from 'react-redux';
import Default from '../components/default';
import * as DefaultActions from '../actions/defaultActions';
import * as TranslationActions from '../actions/translationsActions';
import * as LoginActions from '../actions/loginActions';
import * as CommonActions from '../actions/commonActions';
import * as BankAccountActions from '../actions/bankAccountActions';
import { appConstants } from '../constants/appConstants';

const mapStateToProps = state => ({
  displayLoader: state.displayLoader,
  displayMessage: state.displayMessage,
  infoMessage: state.infoMessage,
  sideNavContent: state.sideNavContent,
  customerLogoUrl: state.customerLogoUrl,
  activityMenu: state.activityMenu,
  translations: state.translations,
  cartLink: state.cartLink,
  banks: state.banks,
  awards: state.awards,
  catalogs: state.catalogs,
  footerLinks: state.footerLinks,
  catalogPoints: state.catalogPoints,
  catalogSymbol: state.catalogSymbol,
  catalogLink: state.catalogLink,
  clientColors: state.clientColors,
  authToken: state.authToken,
  greeting: state.greeting,
  alertsCount: state.alertsCount,
  genericAlerts: state.genericAlerts,
  receiveAlerts: state.receiveAlerts,
  customerId: state.customerId,
  personalInfoValues: state.personalInfoValues,
  preferredLocale: state.preferredLocale,
  customerDateFormat: state.customerDateFormat,
  hasGivenWidgetEnabled: state.hasGivenWidgetEnabled,
  banksCatalog: state.banksCatalog,
  activeLanguage: state.activeLanguage,
  locale: state.locale,
  displaySessionTimeOut: state.displaySessionTimeOut,
  logout: state.logoutValue,
  isDisplaySideBarPanel: state.isDisplaySideBarPanel,
  avatarLink: state.avatarLink,
  tasksCount: state.tasksCount,
  customerTitle: state.customerTitle,
  isDisplayCommonHeaderSideMenu: state.isDisplayCommonHeaderSideMenu,
  customerSTP: state.customerSTP,
  translationsGreatwork: state.translationsGreatwork
});

const mapDispatchToProps = dispatch => ({
  closeDisplayMessage: () => {
    dispatch(DefaultActions.closeDisplayMessage());
  },
  handleNavSelect: (title, url) => {
    dispatch(DefaultActions.handleNavSelect(title, url));
  },
  expandSubscriptions: (isExpanded, isSelected) => {
    dispatch(DefaultActions.expandSubscriptions(isExpanded, isSelected));
  },
  displaySideMenu: (display) => {
    dispatch(DefaultActions.displaySideMenu(display));
  },
  getLayouts: () => {
    dispatch(DefaultActions.getLayouts());
  },
  getAlerts: () => {
    dispatch(DefaultActions.getAlerts());
  },
  getTranslations:(isLangChanged) => {
    dispatch(TranslationActions.getTranslations(isLangChanged));
  },
  getUserName: (name) => {
    dispatch(LoginActions.getUserName(name));
  },
  getUserPassword: (password) => {
    dispatch(LoginActions.getUserPassword(password));
  },
  submitLogin: () => {
    dispatch(LoginActions.submitLogin());
  },
  getPersonalDetails: () => {
    dispatch(DefaultActions.getPersonalDetails());
  },
  getBankDetails: () => {
    dispatch(DefaultActions.getBankDetails());
  },
  customerLogoHome: () => {
    dispatch(DefaultActions.customerLogoHome());
  },
  setActiveLanguage: (language) => {
    dispatch(DefaultActions.setActiveLanguage(language));
  },
  getActiveLanguage: () => {
    dispatch(DefaultActions.getActiveLanguage());
  },
  getCatalogPoints: () => {
    dispatch(DefaultActions.getCatalogPoints());
  },
  displaySession: () => {
    dispatch(CommonActions.displaySession(false));
    dispatch(CommonActions.resetTimer());
  },
  getBankFilter: () => {
    const location = window.location.pathname;
    const index = location.indexOf(appConstants.ROUTE_BANK_ACCOUNT);
    if(index !== -1)
      dispatch(BankAccountActions.applyBankAccountFilters(true));
  },
  displaySideBarPanel: (display) => {
    dispatch(DefaultActions.displaySideBarPanel(display));
    dispatch(CommonActions.resetTimer());
  },
  getAvatar : () => {
    dispatch(DefaultActions.getAvatar());
  },
  displayDialog: (path) => {
    dispatch(DefaultActions.displayDialog(path));
  },
  displayCommonHeaderSideMenu: () => {
    dispatch(DefaultActions.displayCommonHeaderSideMenu());
  },
  getRecieveAlert: (endPoint, code) => {
    if(CommonActions.isSatisfied(code)){
      dispatch(DefaultActions.getRecieveAlert(endPoint));
    }
  },
  initializeVictoriesHeader: () => {
    dispatch(DefaultActions.initializeVictoriesHeader());
  },
  refreshVictoriesHeader: (lang) => {
    dispatch(DefaultActions.refreshVictoriesHeader(lang));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Default);
